import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { LOGOS, ICONS } from "../../utils/assets";

import { loadStripe } from "@stripe/stripe-js";

import AuthenticatedTemplate from "../../components/AuthenticatedTemplate";
import { Footer } from "../../components/Footer";
import { Congratulations } from "../Congratulations";
import Button from "../../components/form/Button";
import ProgressBar from "../../components/ProgressBar";
import { useOrganisationsStore } from "../../stores/organisations-store";
import Input from "../../components/form/Input";
import { useGlobalStore } from "../../stores/global-store";
import { checkboxDataWelcome } from "../../data/checkboxWelcome";

export const Dashboard07Checkout = () => {
  const { selectedOrganisations } = useOrganisationsStore();
  const { fetchDataPaymentType, paymentType } = useGlobalStore();
  const [orgQuantity] = useState(selectedOrganisations.length || 0);

  const [congratsPage, setCongratsPage] = useState(null);
  //State to store the data from Data Base
  const [planPrice, setPlanPrice] = useState(0);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  //State to store the data from Local Storage
  const [services, setServices] = useState([]);
  //--------------------------------------------------
  const [payable, setPayable] = useState(0);
  const gst = 1.15;
  const gstDisplay = "15";
  const [gstIncluded, setGSTincluded] = useState(0);
  const [orderNumber, setOrderNumber] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [discountValue, setDiscountValue] = useState(0);
  const [loadingCoupon, setLoadingCoupon] = useState(false);
  const [couponMessage, setCouponMessage] = useState({
    valid: false,
    message: "",
  });
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [errors, setErrors] = useState({});

  const loadFromLocalStorage = (key, setter) => {
    const data = sessionStorage.getItem(key);
    if (data !== null) {
      setter(JSON.parse(data));
    }
  };

  useEffect(() => {
    const runAwaitFunctions = async () => {
      await fetchDataPaymentType();
    };

    const congrats = JSON.parse(sessionStorage.getItem("LS_CONGRATS") || false);
    if (congrats) {
      setCongratsPage(<Congratulations />);
    } else {
      // Load various values from LocalStorage using a helper function
      loadFromLocalStorage("LS_PRICE_PLAN_PRICE", setPlanPrice);
      loadFromLocalStorage("LS_PRICE_PAYABLE", setPayable);
      loadFromLocalStorage("LS_PRICE_GST_INCLUDED", setGSTincluded);
      loadFromLocalStorage("LS_ORDER_ID", setOrderNumber);
      // Additional actions
      runAwaitFunctions();
    }
  }, []);

  useEffect(() => {
    const selectedServices = JSON.parse(
      sessionStorage.getItem("LS_CHECKED_ITEMS") || "[]"
    );

    const selectedServicesNames = checkboxDataWelcome().filter((option) => {
      return selectedServices.includes(option.value);
    });

    setServices(selectedServicesNames);
  }, []);

  useEffect(() => {}, [
    payable,
    orgQuantity,
    gstIncluded,
    paymentType,
    planPrice,
    orderNumber,
    congratsPage,
  ]);

  const clearInputError = (name, value) => {
    const errorKey = name;

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value !== "") {
        delete newErrors[errorKey];
      }
      return newErrors;
    });
  };

  const getFormattedServices = () => {
    return services
      .map((service, index) => {
        if (index !== 0) {
          return service.title.toLowerCase();
        }
        return service.title;
      })
      .join(", ");
  };

  function paymentTypeHandler(value) {
    setSelectedPaymentType(value);
    if (value) {
      sessionStorage.setItem("LS_PAYMENT_TYPE", JSON.stringify("debit"));
      clearInputError("paymentType", value);
    }
  }
  /**
   * Function to set cart with all information
   */
  async function setCart() {
    let orderNumberLS = "";
    const LS_ORDER_ID = sessionStorage.getItem("LS_ORDER_ID");
    if (LS_ORDER_ID !== null) {
      orderNumberLS = JSON.parse(LS_ORDER_ID);
    }
    const productName =
      "Quickmove service request " +
      orderNumberLS +
      " (" +
      orgQuantity +
      " organisations)";

    const cart = [
      {
        name: productName,
        quantity: 1,
        price: payable,
        total: planPrice,
      },
    ];
    return cart;
  }

  const handleCouponChange = (event) => {
    setCoupon(event.target.value);
    setCouponMessage({ valid: false, message: "" });
  };

  const validateCoupon = async () => {
    if (!coupon) {
      setCouponMessage({
        valid: false,
        message: "Please enter a coupon code.",
      });
      return null;
    }
    setLoadingCoupon(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/checkout/validate-coupon`,
        { coupon }
      );
      const valid = response.data.valid;
      const discount = response.data.discount;
      setDiscountValue(discount);
      setCouponMessage({
        valid: true,
        message: `Coupon is valid! You have a discount of ${discount}%.`,
      });
      return valid;
    } catch (error) {
      setCouponMessage({
        valid: false,
        message:
          error.response?.data?.error || "Invalid coupon. Please try again.",
      });
      console.error(
        "Coupon validation error:",
        error.response?.data?.error || error.message
      );
      setCoupon("");
      return null;
    } finally {
      setLoadingCoupon(false);
    }
  };

  const makePayment = async () => {
    let cart = await setCart();
    setLoadingPayment(true);
    try {
      const stripe = await loadStripe(
        process.env.REACT_APP_STRIPE_PUBLISHED_KEY
      );
      if (!stripe) throw new Error("Stripe failed to initialize.");

      const orderId = JSON.parse(sessionStorage.getItem("LS_ORDER_ID"));
      //Israel updates
      const LS_ORG_QUANT = JSON.parse(
        sessionStorage.getItem("LS_ORGANISATIONS_LIST")
      );
      const orgQuantity = LS_ORG_QUANT.length;
      const body = {
        orgQuantity,
        couponCode: couponMessage.valid ? coupon : null,
      };
      // const body = {
      //   orderId,
      //   coupon: couponMessage.valid ? coupon : null,
      // };
      //End Updates
      const headers = {
        "Content-Type": "application/json",
      };

      const response = await fetch(
        `${process.env.REACT_APP_URL}/checkout/payment`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const session = await response.json(); //session receives the reponse and parse JSON
      // Stripe opens the session with the ID provided from the backend
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      //Error handlers from Stripe request
      if (result?.error) {
        console.error("Stripe Checkout Error:", result.error);
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      alert("Something went wrong during checkout. Please try again.");
    } finally {
      setLoadingPayment(false);
    }
  };

  const handleContinue = async () => {
    const isValid = validateFields();
    if (!isValid) return;
    await makePayment();
  };

  const validateFields = () => {
    let isValid = true;
    let newErrors = {};

    if (!selectedPaymentType && payable > 0 && discountValue !== 100) {
      newErrors["paymentType"] = "Please select a payment type.";
      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  return (
    <>
      <AuthenticatedTemplate>
        <section className="step__container">
          {congratsPage ? (
            congratsPage
          ) : (
            <div className="step__content">
              <div className="checkout">
                <div className="step__header">
                  <img
                    className="logo"
                    src={LOGOS.QUICKMOVE_FLOW}
                    alt="Quickmove logo"
                  />
                  <div>
                    <h1 className="text-md text-md--variant">Checkout</h1>
                    <p className="paragraph-md">
                      Enjoy hassle-free updates! Please complete your payment
                      below
                    </p>
                  </div>
                </div>

                <ProgressBar percentage="84" />

                <div className="checkout__content">
                  <div className="checkout__info">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Selected Organisation
                    </h2>
                    <div className="checkout__info-item">
                      <span className="paragraph-md">Organisations</span>
                      <span className="paragraph-md">
                        {orgQuantity} organisations
                      </span>
                    </div>
                    <div className="checkout__info-item">
                      <span className="paragraph-md">
                        {services.length > 1 ? "Services" : "Service"}
                      </span>
                      <span className="paragraph-md">
                        {getFormattedServices(services)}
                      </span>
                    </div>
                  </div>

                  <div className="checkout__info">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Your Plan
                    </h2>
                    <div className="checkout__info-item">
                      <span className="paragraph-md">Individual Plan</span>
                      <span className="paragraph-md">{planPrice}</span>
                    </div>
                    <div className="checkout__info-item">
                      <span className="paragraph-md">
                        GST &#40;{gstDisplay}%&#41;
                      </span>
                      <span className="paragraph-md">{gstIncluded}</span>
                    </div>
                    <div className="checkout__info-item">
                      <span className="paragraph-md semibold text-highlight">
                        Total Payable
                      </span>
                      <span className="paragraph-md semibold text-highlight">
                        {payable}
                      </span>
                    </div>
                  </div>

                  <div className="checkout__info">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Discount
                    </h2>
                    <div className="checkout__coupon">
                      <Input
                        label="Coupon Code"
                        placeholder="Enter coupon code"
                        className="checkout__input"
                        value={coupon}
                        onChange={(e) => handleCouponChange(e)}
                      />
                      <Button
                        variant="primary"
                        loading={loadingCoupon}
                        onClick={() => validateCoupon()}
                      >
                        Validate
                      </Button>
                    </div>
                    {couponMessage.message && (
                      <p
                        className={`paragraph-md ${
                          couponMessage.valid ? "text-success" : "text-danger"
                        }`}
                      >
                        {couponMessage.message}
                      </p>
                    )}
                  </div>

                  <div className="checkout__info">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Payment Method
                    </h2>
                    <div className="checkout__payment-methods">
                      <div className="checkout__payment-methods-item">
                        <img src={LOGOS.PAYPAL} alt="Pay Pal" />
                      </div>
                      <div className="checkout__payment-methods-item">
                        <img src={LOGOS.VISA} alt="Visa" />
                      </div>
                      <div className="checkout__payment-methods-item">
                        <img src={LOGOS.MASTER} alt="Master" />
                      </div>
                    </div>
                  </div>

                  <div className="checkout__info">
                    <h2 className="paragraph-md semibold paragraph-md--dark">
                      Format payment
                      {payable > 0 && discountValue !== 100 && "*"}
                    </h2>
                    <div className="checkout__format-payment">
                      {paymentType && paymentType.length > 0 ? (
                        paymentType.map((item, index) => (
                          <div
                            className={`checkout__checkbox ${
                              item.Payment_Type_ID === selectedPaymentType
                                ? "checkout__checkbox--active"
                                : ""
                            }`}
                            key={index}
                            onClick={() =>
                              paymentTypeHandler(item.Payment_Type_ID)
                            }
                          >
                            <input
                              type="radio"
                              id={`debit-${index}`}
                              name="formatPayment"
                              value="debit"
                              readOnly
                              checked={
                                item.Payment_Type_ID === selectedPaymentType
                              }
                            />
                            <label className="paragraph-md">
                              {item.Payment_Type_Name}
                            </label>
                          </div>
                        ))
                      ) : (
                        <p className="paragraph-md">Choose a payment type</p>
                      )}
                    </div>
                    {errors.paymentType && (
                      <span className="paragraph-md text-danger">
                        {errors.paymentType}
                      </span>
                    )}
                  </div>
                </div>

                <div className="action-buttons">
                  <Link to="/dashboard-review-details">
                    <Button variant="outlined">Back</Button>
                  </Link>
                  <Button
                    variant="primary"
                    icon={ICONS.CARET_ICON}
                    iconAlt="Caret icon"
                    loading={loadingPayment}
                    onClick={() => handleContinue()}
                  >
                    Continue
                  </Button>
                </div>
                <Footer />
              </div>
            </div>
          )}
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
